import React from "react";
import {
  USER_MANAGEMENT_PATH,
  LAW_FIRM_USER_MANAGEMENT_PATH,
  ORGANISATION_MANAGEMENT_PATH,
  CONTRACT_LIST_PATH,
  ADD_NEW_CONTRACT_PATH,
  EDIT_CONTRACT_PATH,
  CONTRACT_DETAILS_PATH,
  OBLIGATION_DETAILS_PATH,
  TASK_DETAILS_PATH,
  USER_PROFILE,
  SCHEDULE_EXTENSION,
  DASHBOARD_PATH,
  LOGIN_ROUTE,
  REGISTER_ROUTE,
  FORGOT_PASSWORD_ROUTE,
  RESET_PASSWORD_ROUTE,
  SUSPENSTION_EVENT_DETAILS_PATH,
  ROLE_MANAGEMENT_PATH,
  PROJECT_REMINDER_DETAILS_PATH,
} from "configs/AppConfig";

export const publicRoutes = [
  {
    key: "login",
    path: `${LOGIN_ROUTE}`,
    component: React.lazy(
      () => import("views/auth-views/authentication/login"),
    ),
    meta: {
      blankLayout: true,
    },
  },
  {
    key: "register",
    path: `${REGISTER_ROUTE}`,
    component: React.lazy(
      () => import("views/auth-views/authentication/register"),
    ),
  },
  {
    key: "forgot-password",
    path: `${FORGOT_PASSWORD_ROUTE}`,
    component: React.lazy(
      () => import("views/auth-views/authentication/forgot-password"),
    ),
  },
  {
    key: "reset-password",
    path: `${RESET_PASSWORD_ROUTE}`,
    component: React.lazy(
      () => import("views/auth-views/authentication/reset-password"),
    ),
    meta: {
      blankLayout: true,
    },
  },
];

export const protectedRoutes = [
  {
    key: "dashboard.default",
    path: `${DASHBOARD_PATH}`,
    component: React.lazy(() => import("views/app-views/dashboards/default")),
  },
  {
    key: "user.management",
    path: `${USER_MANAGEMENT_PATH}`,
    component: React.lazy(() => import("views/app-views/user-management")),
  },
  {
    key: "lawFirmUser.management",
    path: `${LAW_FIRM_USER_MANAGEMENT_PATH}`,
    component: React.lazy(
      () => import("views/app-views/law-firm-user-management"),
    ),
  },
  {
    key: "organisation.management",
    path: `${ORGANISATION_MANAGEMENT_PATH}`,
    component: React.lazy(
      () => import("views/app-views/organisation-management"),
    ),
  },
  {
    key: "role-management",
    path: `${ROLE_MANAGEMENT_PATH}`,
    component: React.lazy(() => import("views/app-views/role-management")),
  },
  {
    key: "contracts.list",
    path: `${CONTRACT_LIST_PATH}`,
    component: React.lazy(
      () => import("views/app-views/contracts/contract-lists"),
    ),
  },
  {
    key: "contracts.add",
    path: `${ADD_NEW_CONTRACT_PATH}`,
    component: React.lazy(() => import("views/app-views/contracts/add")),
  },
  {
    key: "contracts.edit",
    path: `${EDIT_CONTRACT_PATH}`,
    component: React.lazy(() => import("views/app-views/contracts/add")),
  },
  {
    key: "contracts.details",
    path: `${CONTRACT_DETAILS_PATH}`,
    component: React.lazy(
      () => import("views/app-views/contracts/contract-details"),
    ),
  },
  {
    key: "obligations.details",
    path: `${OBLIGATION_DETAILS_PATH}`,
    component: React.lazy(
      () =>
        import("views/app-views/contracts/contract-details/components/ObligationsView"),
    ),
  },
  {
    key: "tasks.details",
    path: `${TASK_DETAILS_PATH}`,
    component: React.lazy(
      () =>
        import("views/app-views/contracts/contract-details/components/ProjectScheduleView"),
    ),
  },
  {
    key: "user.profile",
    path: `${USER_PROFILE}`,
    component: React.lazy(() => import("views/app-views/profile")),
  },
  {
    key: "schedule-extension",
    path: `${SCHEDULE_EXTENSION}`,
    component: React.lazy(
      () =>
        import("views/app-views/contracts/add/components/ProjectScheduleSection/ExtensionDetailsPage"),
    ),
  },
  {
    key: "suspension.details",
    path: `${SUSPENSTION_EVENT_DETAILS_PATH}`,
    component: React.lazy(
      () =>
        import("views/app-views/contracts/contract-details/components/SuspensionEventsView"),
    ),
  },
  {
    key: "project-reminders.details",
    path: `${PROJECT_REMINDER_DETAILS_PATH}`,
    component: React.lazy(
      () =>
        import("views/app-views/contracts/contract-details/components/ProjectReminderView"),
    ),
  },
];
